import { computed, toRef, ref } from 'vue';
import { nanoid } from 'nanoid';
import { Data, Series } from '@/features/reports/models';

export function useReportData(props: { data: Data | undefined; loadedData: boolean }) {
  const reportId = ref(nanoid(7));
  const dataRef = toRef(props, 'data');
  const loadedDataRef = toRef(props, 'loadedData');

  const isDataEmpty = computed(() => !dataRef.value || !dataRef.value.series || dataRef.value.series.length === 0);
  const isDataLoaded = computed(() => loadedDataRef.value);

  function createBlankSeries(name: string, displayName: string | undefined = undefined): Series {
    return {
      name,
      displayName: displayName || name,
      data: dataRef.value?.scale.labels.map(() => 0) || [],
    };
  }

  return {
    reportId,
    isDataEmpty,
    isDataLoaded,
    createBlankSeries,
  };
}
